<template>
	<div
		class="wrapper"
		v-if="active"
	>
		<TComponent
			v-if="content.component"
			:component="content.component"
			last
		/>
	</div>
</template>
<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import ECommerceProductMixin from "~/components/ecommerce/ECommerceProductMixin/ECommerceProductMixin.js";
export default defineNuxtComponent({
	name: "ECommerceWrapper",
	mixins: [GizmoComponentMixin, ECommerceProductMixin],

	computed: {
		active() {
			return this.content?.eCommerceCategory?.indexOf(this.eCommerceProduct?.category) !== -1;
		},
	},
});
</script>
<style lang="scss" scoped></style>
